import { render } from "./StatusTagFournisseur.vue?vue&type=template&id=74f89134&scoped=true&ts=true"
import script from "./StatusTagFournisseur.vue?vue&type=script&lang=ts"
export * from "./StatusTagFournisseur.vue?vue&type=script&lang=ts"

import "./StatusTagFournisseur.vue?vue&type=style&index=0&id=74f89134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f89134"]])

export default __exports__